<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <div class="date_block">
        <el-date-picker
          v-model="query.ptdate"
          type="month"
          placeholder="选择月份"
        value-format="yyyy-MM">
        </el-date-picker>
      </div>
        <el-select v-model="query.state" placeholder="审核状态" class="handle-select mr10">
          <el-option label="审核状态" value=""></el-option>
          <el-option key="0" label="待审核" value="0"></el-option>
          <el-option key="1" label="审核通过" value="1"></el-option>
          <el-option key="2" label="审核未通过" value="2"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="findBusiness">查询</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="newAdd">新建</el-button>
      </div>
      <el-table :data="tableData" border stripe max-height="450px" >
        <el-table-column type="index" :index="indexMethod" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="地区" width="80"></el-table-column>
        <el-table-column prop="pt_date" label="月报时间"></el-table-column>
        <el-table-column prop="tb_tel" label="填表人(联系电话)" width="160"></el-table-column>
        <el-table-column prop="tb_date" label="填表时间" :formatter="formatter"></el-table-column>
        <el-table-column prop="sp_spyj" label="审核状态" :formatter="formatter"></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text"  @click="searchfor(scope.$index, scope.row)">查看</el-button>
            <el-button type="text"  @click="newAdd(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size = "pageSize"
          layout="total,sizes,prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="县(自治县、市)配套费征收统计月报表"
      :visible.sync="dialogVisible"
      width="85%"
      :before-close="handleClose"
      top="8px"
      center>
      <filledit :id="id"  ref="filledit" @change-type="onChangeType"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
       <!-- <el-button type="primary" @click="dialogVisible = false">保存</el-button>-->
        <el-button type="primary" @click="filloutedit">申报</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="县(自治县、市)配套费征收统计月报表"
      :visible.sync="dialogVisible2"
      width="85%"
      :before-close="handleClose2"
      top="8px"
      center>
      <search  ref="search"/>
    </el-dialog>
  </div>
</template>

<script>
  import  filledit from '../edit/filledit.vue'
  import  search from '../edit/search.vue'
  import axios from '@/utils/axios.js'
  import util from '@/utils/util.js'
  import {Decrypt,Encrypt} from '@/utils/crypto';
    export default {
        name: "fillout",
      data() {
        return {
          id : "",
          dialogVisible: false,
          dialogVisible2:false,
          currentPage : 1,
          pageSize : 10,
          total : 0,
          tableData: [],//列表数据
          query: {//查询条件
            ptdate: '',//时间值
            state:'',// 审核状态
          },
        }
      },
      components:{
        filledit,search
      },
      mounted(){
        this.findBusiness();

      },

      methods:{
        open() {
          this.$alert('该条数据不能被编辑', '提示', {
            confirmButtonText: '确定'
          });
        },
        cancel(){
          this.dialogVisible = false;
          this.$refs.filledit.$refs['ruleForm'].resetFields();//点击取消清除缓存值
        },


        searchfor(index,row){//查看按钮
          this.dialogVisible2=true;
          setTimeout(() => {
            this.$refs.search.examine(index,row);
          },0)
        },
        indexMethod(index) { // 序列号生成
          return (index * 1)+1;
        },
        // 表格列格式化
       formatter(row, column, cellValue) {
          if (column.property == "sp_spyj") {
            if(cellValue == "0" ){
              return "待审核";
            }
            if(cellValue == "1" ){
              return "审核通过";
            }
            if(cellValue == "2" ){
              return "审核未通过";
            }
          } else if(column.property == "tb_date"){
              return util.formatDate(new Date(cellValue),"yyyy-MM-dd");
          }
        },
        newAdd(row){//点击新建时生成index
         if(row.sp_spyj == 0 || row.sp_spyj == 1){
           this.open();
           return;
         }
          this.id = "";
          if(row &&　row.id){
            this.id = row.id;
          }
          this.dialogVisible = true;
            setTimeout(() => {
              this.$refs.filledit.initFunction();
              this.findBusiness();
            },0)
        },
        onChangeType () { // type是子组件$emit传递的参数
          this.dialogVisible = true;
        },
        filloutedit(){//弹框中的申报按钮
          setTimeout(() => {
            this.$refs.filledit.submiteditForm();
          },0)
          /*this.findBusiness();*/
          this.dialogVisible = false;
        },
        handleClose(done) {//关闭弹框提示
          this.$confirm('确认关闭？')
            .then(_ => {
              this.$refs.filledit.$refs['ruleForm'].resetFields();//关闭弹框清除缓存值
              done();
            })
            .catch(_ => {});
        },
        handleClose2(done) {//点击查看的关闭弹框提示
          this.$confirm('确认关闭？')
            .then(_ => {
              done();
            })
            .catch(_ => {});
        },
        // 分页导航
        handleSizeChange(val) {
          this.pageSize = val;
          this.findBusiness();
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.findBusiness();
        },
        findBusiness(){//月报列表查询
          debugger
          console.log("xxxxxxxxxxxxxxxxxxxx")
          let _this = this
          axios.post('/base/index/indexServise',{
            "pageSize":_this.pageSize,
            "NowPage":_this.currentPage,
            "ptdate":this.query.ptdate,
            "state":this.query.state
          }).then(function(res){
            console.log("=======================")
            var data=res.data.data;
            _this.pageSize = data.pageSize;
            _this.total = data.total;
            _this.currentPage = data.nowPage;
            data.content.forEach(function (item) {
              console.log("===========")
              console.log(item.tb_tel);
              console.log("--------------------")
              item.tb_tel = Decrypt(item.tb_tel);
              console.log(item.tb_tel);
            });
            _this.tableData = data.content;
            _this.query.count = data.total;
          })
        }
      }
    }
</script>

<style scoped>
  .container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .handle-box {
    margin-bottom: 20px;
    flex-wrap:nowrap;
    display: flex;
    justify-content:flex-end;

  }
  .date_block{
    margin-right: 8px;
  }
  .handle-select {
    width: 120px;
  }

  .table{
    width: 100%;
    font-size: 14px;

  }
  .mr10{
    margin-right: 10px;
  }
  .pagination {
    margin: 20px 0;
    text-align: right;
  }
/*

  .table{
    height: 550px;
    overflow-y: scroll;
  }
*/


</style>



// WEBPACK FOOTER //
// src/views/common/edit/fillout.vue